module.exports = __webpack_public_path__ + "empty_views.png?23e21e77eda7940ce256bf6f397c5e31";